// StudioDev Theme JavaScript

// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavClose = document.getElementById('mobile-nav-close');

  if (mobileMenuToggle && mobileNav) {
    mobileMenuToggle.addEventListener('click', function() {
      mobileNav.classList.add('active');
    });
  }

  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', function() {
      mobileNav.classList.remove('active');
    });
  }

  // Close mobile nav when clicking outside
  document.addEventListener('click', function(event) {
    if (mobileNav && mobileNav.classList.contains('active')) {
      if (!mobileNav.contains(event.target) && !mobileMenuToggle.contains(event.target)) {
        mobileNav.classList.remove('active');
      }
    }
  });
});

// Cart functionality
class CartManager {
  constructor() {
    this.init();
  }

  init() {
    this.updateCartCount();
  }

  async updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartCountElements = document.querySelectorAll('.cart-count');
      
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  async addToCart(variantId, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });

      if (response.ok) {
        await this.updateCartCount();
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error adding to cart:', error);
      return false;
    }
  }
}

// Initialize cart manager
const cartManager = new CartManager();

// Product variant selector
document.addEventListener('DOMContentLoaded', function() {
  const variantSelectors = document.querySelectorAll('.variant-selector');
  
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function() {
      const selectedVariantId = this.value;
      const priceElement = this.closest('.product-main')?.querySelector('.product-price');
      
      // Update price based on variant selection
      if (priceElement && this.selectedOptions[0]) {
        const price = this.selectedOptions[0].dataset.price;
        if (price) {
          priceElement.textContent = price;
        }
      }
    });
  });
});

// Add to cart button handler
document.addEventListener('DOMContentLoaded', function() {
  const addToCartButtons = document.querySelectorAll('.add-to-cart-btn');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      e.preventDefault();
      
      const variantId = this.dataset.variantId;
      const quantity = parseInt(this.dataset.quantity || 1);
      
      if (!variantId) {
        console.error('No variant ID found');
        return;
      }

      // Disable button and show loading state
      const originalText = this.textContent;
      this.disabled = true;
      this.textContent = 'Adding...';
      
      const success = await cartManager.addToCart(variantId, quantity);
      
      if (success) {
        this.textContent = 'Added!';
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, 2000);
      } else {
        this.textContent = 'Error - Try Again';
        setTimeout(() => {
          this.textContent = originalText;
          this.disabled = false;
        }, 2000);
      }
    });
  });
});

// Spec Finder Filter
document.addEventListener('DOMContentLoaded', function() {
  const specFinderForm = document.getElementById('spec-finder-form');
  
  if (specFinderForm) {
    const processorFilter = document.getElementById('processor-filter');
    const manufacturerFilter = document.getElementById('manufacturer-filter');
    const priceFilter = document.getElementById('price-filter');
    const productCards = document.querySelectorAll('.spec-product-card');

    function filterProducts() {
      const selectedProcessor = processorFilter?.value.toLowerCase() || '';
      const selectedManufacturer = manufacturerFilter?.value.toLowerCase() || '';
      const selectedPrice = priceFilter?.value || '';

      productCards.forEach(card => {
        const processor = card.dataset.processor?.toLowerCase() || '';
        const manufacturer = card.dataset.manufacturer?.toLowerCase() || '';
        const price = parseFloat(card.dataset.price) || 0;

        let show = true;

        // Filter by processor
        if (selectedProcessor && !processor.includes(selectedProcessor)) {
          show = false;
        }

        // Filter by manufacturer
        if (selectedManufacturer && manufacturer !== selectedManufacturer) {
          show = false;
        }

        // Filter by price range
        if (selectedPrice) {
          const [min, max] = selectedPrice.split('-').map(Number);
          if (max) {
            if (price < min || price > max) show = false;
          } else {
            if (price < min) show = false;
          }
        }

        card.style.display = show ? 'block' : 'none';
      });

      // Update results count
      const visibleCount = Array.from(productCards).filter(card => card.style.display !== 'none').length;
      const resultsCount = document.getElementById('results-count');
      if (resultsCount) {
        resultsCount.textContent = `${visibleCount} product${visibleCount !== 1 ? 's' : ''} found`;
      }
    }

    processorFilter?.addEventListener('change', filterProducts);
    manufacturerFilter?.addEventListener('change', filterProducts);
    priceFilter?.addEventListener('change', filterProducts);
  }
});

// Smooth scroll for anchor links
document.addEventListener('DOMContentLoaded', function() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const href = this.getAttribute('href');
      if (href === '#') return;
      
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});
